import { Checkbox } from '@mui/material';
import { InputType } from './../EditComponent';

interface CheckboxEditProps {
  localVal: InputType;
  handleSave: (value: InputType) => void;
  handleClose: () => void;
}

export const CheckboxEditComponent = ({ localVal, handleSave, handleClose }: CheckboxEditProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleSave(event.target.checked);
    handleClose();
  };

  return (
    <Checkbox
      checked={localVal as boolean}
      size="small"
      onChange={handleChange}
    />
  );
};
